import React from "react";
import SkillCircle from './SkillCircle';

const Skills = () =>{

    const skills = [
        { skill: 'HTML5, CSS, JS, Bootstrap, Tailwind ', percentage: 85 },
        { skill: 'Java, Jakarta', percentage: 75 },
        { skill: 'Spring Ecosystem, Spring Boot, Hibernate, JPA', percentage: 80 },
        { skill: 'Spring Security', percentage: 70 },
        { skill: 'PHP, Laravel', percentage: 65 },
        { skill: 'SQL, Oracle', percentage: 75 },
        { skill: 'GIT, SVN', percentage: 85 },
        { skill: 'IDEs: VSCode, Eclipse, Intellij, Spyder', percentage: 90 }
    ];
    return(
        <section className="skills">
            <div className="title">
                <h3>Skills</h3>
            </div>
            <div>
                {skills.map((skill, index) => (
                    <SkillCircle key={index} skill={skill.skill} percentage={skill.percentage} />
                ))}
            </div>

        </section>
    );
}

export default Skills;